module.exports = __webpack_public_path__ + "static/media/pre-break.1f4549c1.svg";